/* global google */
import React, { useEffect, useRef, useState } from "react"
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBIcon,
  MDBInput,
  MDBListGroup,
  MDBListGroupItem,
} from "mdb-react-ui-kit"
import { Loader } from "@googlemaps/js-api-loader"
import { GOOGLE_MAPS_API_KEY } from "../env/env"
import delivery_scooter from "../images/delivery-scooter.png"
import deliveryPriceService from "../services/api/deliveryPriceService"
import "../css/AddressModal.css"
import MarkerInfoWindow from "./MarkerInfoWindow"
import AddressForm from "./AddressForm"
import getAddressesService from "../services/api/getAddressesService"
import toast from "react-hot-toast"
import { createRoot } from "react-dom/client"

export default function AddressModal({ isOpen, onClose }) {
  const [coordinates, setCoordinates] = useState({ lat: 42.8746, lng: 74.5698 })
  const [orginCoordinates, setOriginCoordinates] = useState()
  const [suggestions, setSuggestions] = useState([])
  const [searchText, setSearchText] = useState("")
  const mapRef = useRef(null)
  const searchInputRef = useRef(null)
  const [maxDeliveryDistance, setMaxDeliveryDistance] = useState()
  const [showAddressButtons, setShowAddressButtons] = useState(false)
  const [showMapRef, setShowMapRef] = useState(true)
  const [selectedButton, setSelectedButton] = useState("Home")
  const [formattedAddress, setFormattedAddress] = useState()
  const [showAddressForm, setShowAddressForm] = useState(false)
  const [selectedAddress, setSelectedAddress] = useState()
  const [selectedEditAddress, setEditSelectedAddress] = useState()
  const [mapToggle, setMapToggle] = useState()

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName)
  }

  const [addressesData, setAddressesData] = useState([])
  const getAddresses = async () => {
    try {
      const token = localStorage.getItem("token")
      if (!token && localStorage.getItem("isGuestUser") === "true") {
        setAddressesData(
          JSON.parse(localStorage.getItem("guestAddresses")) || []
        )
        return
      }
      const addressesDataResponse = await getAddressesService.get(token)
      console.log("Data: ", addressesDataResponse.data.data)
      setAddressesData(addressesDataResponse.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    console.log(localStorage)
    console.log(localStorage.getItem("guestAddresses"))
    getAddresses()
  }, [])

  const handleSaveAddress = () => {
    console.log("Address Saved!")
    handleBackButtonClick()
    getAddresses()
  }

  const handleBackButtonClick = () => {
    setShowAddressButtons(false)
    setShowAddressForm(false)
    setShowMapRef(true)
  }

  const handleEntranceMapClick = () => {
    setShowAddressButtons(false)
    setShowAddressForm(false)
    setShowMapRef(true)
  }

  const handleAddressClick = (address) => {
    setSelectedAddress(address)
    localStorage.setItem("deliveryType", "delivery")
    localStorage.setItem("currentAddress", JSON.stringify(address))
    handleCloseModal()
    toast.success("Delivery Address Selected")
    console.log("Current Address: ", localStorage.getItem("currentAddress"))
  }

  const handleEditAddressClick = (address) => {
    let selectedEditButton
    if (JSON.parse(address.street_house_number).type == "apartment") {
      selectedEditButton = "Apartment"
    } else if (JSON.parse(address.street_house_number).type == "home") {
      selectedEditButton = "Home"
    } else if (JSON.parse(address.street_house_number).type == "office") {
      selectedEditButton = "Office"
    } else {
      selectedEditButton = "Other"
    }

    console.log("Edit: ", address)
    setSelectedButton(selectedEditButton)
    setEditSelectedAddress(address)
    setShowMapRef(false)
    setShowAddressButtons(true)
    setShowAddressForm(true)
  }

  useEffect(() => {
    const getDeliveryDistance = async () => {
      const getDeliveryDistanceResponse = await deliveryPriceService.getPrice()

      const distances = getDeliveryDistanceResponse.data.data

      const maxDistanceObj = distances.reduce((maxObj, item) => {
        return item.max_distance_km > (maxObj?.max_distance_km || 0)
          ? item
          : maxObj
      }, null)

      const max_distance_m = maxDistanceObj.max_distance_km * 1000
      console.log("Maximum Delivery Distance in meters:", max_distance_m)
      setMaxDeliveryDistance(max_distance_m)
      setCoordinates({
        lat: maxDistanceObj.shop.lat_long.latitude,
        lng: maxDistanceObj.shop.lat_long.longitude,
      })
      setOriginCoordinates({
        lat: maxDistanceObj.shop.lat_long.latitude,
        lng: maxDistanceObj.shop.lat_long.longitude,
      })
    }
    getDeliveryDistance()
  }, [])

  useEffect(() => {
    if (isOpen && maxDeliveryDistance && orginCoordinates) {
      const loader = new Loader({
        apiKey: GOOGLE_MAPS_API_KEY,
        libraries: ["places"],
        version: "weekly",
      })

      loader.load().then(() => {
        const { map, marker, infoWindow } = initializeMap(coordinates)

        const circle = new google.maps.Circle({
          center: { lat: coordinates.lat, lng: coordinates.lng },
          radius: 5000, // Radius in meters
        })

        const autocomplete = new google.maps.places.Autocomplete(
          searchInputRef.current,
          {
            fields: ["geometry", "formatted_address"],
            types: ["address"],
          }
        )

        autocomplete.setBounds(circle.getBounds())
        autocomplete.setOptions({ strictBounds: true })

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace()
          if (place.geometry) {
            const newCoords = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            }

            setFormattedAddress(place.formatted_address)
            setCoordinates(newCoords)
            const distance = calculateDistance(newCoords, orginCoordinates)
            infoWindow.setContent(
              <MarkerInfoWindow
                formatted_address={place.formatted_address}
                distance={distance}
                maxDeliveryDistance={maxDeliveryDistance}
              />
            )
            infoWindow.open(map, marker)
          }
        })
      })
    }
  }, [isOpen, maxDeliveryDistance, orginCoordinates, showMapRef, mapToggle])

  const initializeMap = (center) => {
    const map = new google.maps.Map(mapRef.current, {
      center,
      zoom: 18,
    })

    const marker = new google.maps.Marker({
      position: center,
      map,
      draggable: true,
      crossOnDrag: false,
      icon: {
        url: require("../images/pin_fixed.png"),
        scaledSize: new google.maps.Size(40, 50),
      },
    })

    const handlePointClick = () => {
      setEditSelectedAddress(null)
      setShowMapRef(false)
      setShowAddressButtons(true)
      setShowAddressForm(true)
    }

    const generateInfoWindowContent = (
      address,
      distance,
      maxDeliveryDistance
    ) => {
      const container = document.createElement("div")

      const root = createRoot(container)

      root.render(
        <MarkerInfoWindow
          formatted_address={address}
          distance={distance}
          maxDeliveryDistance={maxDeliveryDistance}
          handlePointClick={handlePointClick}
        />
      )
      return container
    }

    function MarkerInfoWindow({
      distance,
      maxDeliveryDistance,
      formatted_address,
      handlePointClick,
    }) {
      return (
        <div style={{ display: "flex", alignItems: "center", padding: "10px" }}>
          <div style={{ marginRight: "8px" }}>
            <img src={delivery_scooter} alt="icon" width="30" />
          </div>
          <div>
            <p style={{ margin: "0" }}>
              <b>{formatted_address}</b>
            </p>
            {distance <= maxDeliveryDistance ? (
              <button
                onClick={handlePointClick}
                style={{
                  background: "none",
                  border: "none",
                  color: "red",
                  fontSize: "12px",
                  fontWeight: "bold",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
              >
                Use this point
              </button>
            ) : (
              <p
                style={{
                  margin: "0",
                  color: "gray",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                We don't deliver here
              </p>
            )}
          </div>
        </div>
      )
    }

    const geocoder = new google.maps.Geocoder()
    const infoWindow = new google.maps.InfoWindow({ disableAutoPan: true })

    marker.addListener("dragstart", () => {
      marker.setIcon({
        url: require("../images/pin_floating.png"),
        scaledSize: new google.maps.Size(40, 60),
      })
    })

    marker.addListener("dragend", () => {
      const newPos = marker.getPosition()
      const lat = newPos.lat()
      const lng = newPos.lng()
      setCoordinates({ lat, lng })

      const distance = calculateDistance({ lat, lng }, orginCoordinates)

      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address
          const content = generateInfoWindowContent(
            address,
            distance,
            maxDeliveryDistance
          )
          setFormattedAddress(address)
          infoWindow.setContent(content)
          infoWindow.setPosition(newPos)
          infoWindow.open(map, marker)
        } else {
          console.error("Geocoder failed:", status)
          infoWindow.setContent(
            `<p style="color: red; font-weight: bold;">Unable to fetch location details</p>`
          )
          infoWindow.open(map, marker)
        }
      })

      marker.setIcon({
        url: require("../images/pin_fixed.png"),
        scaledSize: new google.maps.Size(40, 50),
      })
    })

    return { map, marker, infoWindow }
  }

  // Function to calculate the distance between two coordinates
  const calculateDistance = (coord1, coord2) => {
    if (!coord1 || !coord2) return Infinity

    const R = 6371e3 // Earth's radius in meters
    const lat1 = (coord1.lat * Math.PI) / 180
    const lat2 = (coord2.lat * Math.PI) / 180
    const deltaLat = ((coord2.lat - coord1.lat) * Math.PI) / 180
    const deltaLng = ((coord2.lng - coord1.lng) * Math.PI) / 180

    const a =
      Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(lat1) *
        Math.cos(lat2) *
        Math.sin(deltaLng / 2) *
        Math.sin(deltaLng / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

    return R * c // Distance in meters
  }

  useEffect(() => {
    if (isOpen) {
      const loader = new Loader({
        apiKey: GOOGLE_MAPS_API_KEY,
        libraries: ["places"],
        version: "weekly",
      })

      loader.load().then(() => {
        // Define map options, including center and zoom
        const mapOptions = {
          center: { lat: coordinates.lat, lng: coordinates.lng }, // Set initial center
          zoom: 12, // Adjust zoom level
        }

        // Initialize map, marker, and infoWindow
        const { map, marker, infoWindow } = initializeMap(coordinates)

        // Define a circular radius using LatLngBounds for Autocomplete
        const circle = new google.maps.Circle({
          center: { lat: coordinates.lat, lng: coordinates.lng }, // Center for the radius
          radius: 10000, // Radius in meters (5km in this case)
        })

        const autocomplete = new google.maps.places.Autocomplete(
          searchInputRef.current,
          {
            fields: ["geometry", "formatted_address"],
            types: ["address"],
          }
        )

        // Restrict autocomplete results to within the circle
        autocomplete.setBounds(circle.getBounds())
        autocomplete.setOptions({ strictBounds: true }) // Enforce strict bounds (optional)

        // Handle place selection in Autocomplete
        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace()
          if (place.geometry) {
            const newCoords = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            }

            setCoordinates(newCoords) // Update coordinates in state
            setFormattedAddress(place.formatted_address)
            const distance = calculateDistance(newCoords, orginCoordinates)

            // Move marker and map to the new location
            map.setCenter(newCoords)
            marker.setPosition(newCoords)

            // Create and render the InfoWindow content dynamically with React
            const content = generateInfoWindowContent(
              place.formatted_address,
              distance,
              maxDeliveryDistance
            )

            // Set InfoWindow position and content
            infoWindow.setContent(content)
            infoWindow.open(map, marker)
          }
        })
      })
    }
  }, [isOpen])

  // Function to generate content for the InfoWindow
  const generateInfoWindowContent = (
    address,
    distance,
    maxDeliveryDistance
  ) => {
    // Create a new div to hold the React component
    const container = document.createElement("div")

    // Create a root for rendering the React component
    const root = createRoot(container)

    // Use root.render to render the MarkerInfoWindow component into this div
    root.render(
      <MarkerInfoWindow
        formatted_address={address}
        distance={distance}
        maxDeliveryDistance={maxDeliveryDistance}
        handlePointClick={handlePointClick} // pass the click handler
      />
    )

    // Return the outer HTML content of the container (this will include the rendered React component)
    return container.innerHTML
  }

  // MarkerInfoWindow Component
  function MarkerInfoWindow({
    distance,
    maxDeliveryDistance,
    formatted_address,
    handlePointClick,
  }) {
    return (
      <div style={{ display: "flex", alignItems: "center", padding: "10px" }}>
        <div style={{ marginRight: "8px" }}>
          <img src={delivery_scooter} alt="icon" width="30" />
        </div>
        <div>
          <p style={{ margin: "0" }}>
            <b>{formatted_address}</b>
          </p>
          {distance <= maxDeliveryDistance ? (
            <button
              onClick={handlePointClick} // Using onClick with the passed function
              style={{
                background: "none",
                border: "none",
                color: "red",
                fontSize: "12px",
                fontWeight: "bold",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              Use this point
            </button>
          ) : (
            <p
              style={{
                margin: "0",
                color: "gray",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              We don't deliver here
            </p>
          )}
        </div>
      </div>
    )
  }

  const handlePointClick = () => {
    setEditSelectedAddress(null)
    setShowMapRef(false)
    setShowAddressButtons(true)
    setShowAddressForm(true)
  }

  const handleSearchChange = (e) => {
    const query = e.target.value
    setSearchText(query)

    if (query.length > 2) {
      const service = new google.maps.places.PlacesService(mapRef.current)
      const request = {
        query,
        fields: ["place_id", "formatted_address", "geometry"],
        location: new google.maps.LatLng(coordinates.lat, coordinates.lng),
        radius: 5000,
      }

      service.textSearch(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          const filteredResults = results.filter((result) => {
            const resultLocation = result.geometry.location
            const distance =
              google.maps.geometry.spherical.computeDistanceBetween(
                new google.maps.LatLng(coordinates.lat, coordinates.lng),
                resultLocation
              )
            return distance <= 20000
          })

          setSuggestions(filteredResults)
        } else {
          setSuggestions([])
        }
      })
    } else {
      setSuggestions([])
    }
  }

  const handleSuggestionClick = (address, coords) => {
    setSearchText(address)
    setCoordinates(coords)
    setSuggestions([])

    const { map, marker, infoWindow } = initializeMap(coords)

    const distance = calculateDistance(coords, orginCoordinates)

    setFormattedAddress(address)
    const contentElement = generateInfoWindowContentt(
      address,
      distance,
      maxDeliveryDistance
    )
    infoWindow.setContent(contentElement)
    infoWindow.open(map, marker)
  }

  const generateInfoWindowContentt = (
    address,
    distance,
    maxDeliveryDistance
  ) => {
    const container = document.createElement("div")

    const root = createRoot(container)

    root.render(
      <MarkerInfoWindow
        formatted_address={address}
        distance={distance}
        maxDeliveryDistance={maxDeliveryDistance}
        handlePointClick={handlePointClick}
      />
    )
    return container
  }

  function MarkerInfoWindow({
    distance,
    maxDeliveryDistance,
    formatted_address,
    handlePointClick,
  }) {
    return (
      <div style={{ display: "flex", alignItems: "center", padding: "10px" }}>
        <div style={{ marginRight: "8px" }}>
          <img src={delivery_scooter} alt="icon" width="30" />
        </div>
        <div>
          <p style={{ margin: "0" }}>
            <b>{formatted_address}</b>
          </p>
          {distance <= maxDeliveryDistance ? (
            <button
              onClick={handlePointClick} // Using onClick with the passed function
              style={{
                background: "none",
                border: "none",
                color: "red",
                fontSize: "12px",
                fontWeight: "bold",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              Use this point
            </button>
          ) : (
            <p
              style={{
                margin: "0",
                color: "gray",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              We don't deliver here
            </p>
          )}
        </div>
      </div>
    )
  }

  const handleCloseModal = () => {
    onClose()
  }

  useEffect(() => {
    if (searchText.trim() === "") {
      mapToggle ? setMapToggle(false) : setMapToggle(true)
    }
  }, [searchText])

  return (
    <>
      <MDBModal open={isOpen} tabIndex={-1}>
        <MDBModalDialog style={{ maxWidth: "80%", height: "90%" }}>
          <MDBModalContent style={{ height: "100%" }}>
            <MDBModalHeader>
              <div className="title-div">
                <MDBIcon
                  icon="angle-left"
                  size="2x"
                  color="none"
                  onClick={handleBackButtonClick}
                  style={{ cursor: "pointer" }}
                />
                <MDBModalTitle>Delivery Address</MDBModalTitle>
              </div>

              <div style={{ display: "flex", gap: "60px" }}>
                <MDBInput
                  ref={searchInputRef}
                  type="text"
                  value={searchText}
                  onChange={handleSearchChange}
                  className="form-control mx-5"
                  style={{ flex: 1 }}
                />
                <MDBIcon
                  icon="times"
                  size="1x"
                  color="none"
                  onClick={handleCloseModal}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </MDBModalHeader>
            <MDBModalBody style={{ overflowY: "auto", height: "380px" }}>
              {suggestions.length > 0 && (
                <MDBListGroup className="mt-3 mb-3">
                  {suggestions.map((suggestion) => (
                    <MDBListGroupItem
                      key={suggestion.place_id}
                      onClick={() =>
                        handleSuggestionClick(suggestion.formatted_address, {
                          lat: suggestion.geometry.location.lat(),
                          lng: suggestion.geometry.location.lng(),
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {suggestion.formatted_address}
                    </MDBListGroupItem>
                  ))}
                </MDBListGroup>
              )}

              {showMapRef && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "20px",
                    height: "100%",
                  }}
                >
                  {/* Left: Address List */}
                  <div
                    className="address-container"
                    style={{
                      flex: 1,
                      maxWidth: "100%",
                      padding: "10px",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                      maxHeight: "100%",
                    }}
                  >
                    <h5>Where shall we deliver to?</h5>
                    <div
                      style={{
                        marginTop: "10px",
                        maxWidth: "100%",
                        maxHeight: "calc(100vh - 150px)",
                        height: "100%",
                        overflowY: "auto",
                        paddingRight: "10px",
                        scrollbarWidth: "thin",
                      }}
                    >
                      {addressesData.length > 0 ? (
                        addressesData.map((address, index) => {
                          const isLast = index === addressesData.length - 1

                          return (
                            <div
                              key={address.id}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px",
                                borderBottom: isLast
                                  ? "none"
                                  : "1px solid #ddd",
                                cursor: "pointer",
                                backgroundColor:
                                  selectedAddress?.id === address.id
                                    ? "#f0f8ff"
                                    : "transparent",
                              }}
                              onClick={() => handleAddressClick(address)}
                            >
                              <div>
                                <p style={{ fontWeight: "bold", margin: "0" }}>
                                  {JSON.parse(address.street_house_number)?.type
                                    ? JSON.parse(address.street_house_number)
                                        .type.charAt(0)
                                        .toUpperCase() +
                                      JSON.parse(
                                        address.street_house_number
                                      ).type.slice(1)
                                    : ""}
                                </p>
                                <p style={{ margin: "0", fontSize: "0.9rem" }}>
                                  {JSON.parse(address.street_house_number)
                                    ?.address || "No address found"}
                                </p>
                              </div>
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  minWidth: "40px",
                                  minHeight: "40px",
                                  borderRadius: "50%",
                                  transition: "background-color 0.3s ease",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "#f0f0f0")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "transparent")
                                }
                                onClick={(e) => {
                                  e.stopPropagation()
                                  handleEditAddressClick(address)
                                }}
                              >
                                <MDBIcon
                                  icon="pen"
                                  size="2x"
                                  color="none"
                                  style={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            </div>
                          )
                        })
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <p style={{ fontSize: "1.2rem", color: "#888" }}>
                            No addresses found
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Right: Map */}

                  {showMapRef && (
                    <div
                      className="map-container"
                      ref={mapRef}
                      style={{
                        height: "100%" /* Adjust height for mobile */,
                        width: "100%",
                      }}
                    ></div>
                  )}
                </div>
              )}
              {showAddressForm && (
                <AddressForm
                  selectedButton={selectedButton}
                  formattedAddress={formattedAddress}
                  coords={coordinates}
                  handleEntranceMapClick={handleEntranceMapClick}
                  handleSaveAddress={handleSaveAddress}
                  selectedEditAddress={selectedEditAddress}
                />
              )}
            </MDBModalBody>

            <MDBModalFooter style={{ height: "100px" }}>
              {showAddressButtons && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h5>What kind of place is this?</h5>
                  </div>
                  <div className="res-btns">
                    <button
                      className={`icon-button-1 ${
                        selectedButton === "Home" ? "selected" : ""
                      }`}
                      onClick={() => handleButtonClick("Home")}
                    >
                      <span className="icon-1">
                        <i className="fas fa-home"></i>
                      </span>
                      <span className="text-1">Home</span>
                    </button>
                    <button
                      className={`icon-button-1 ${
                        selectedButton === "Apartment" ? "selected" : ""
                      }`}
                      onClick={() => handleButtonClick("Apartment")}
                    >
                      <span className="icon-1">
                        <i className="fas fa-building"></i>
                      </span>
                      <span className="text-1">Apartment</span>
                    </button>
                    <button
                      className={`icon-button-1 ${
                        selectedButton === "Office" ? "selected" : ""
                      }`}
                      onClick={() => handleButtonClick("Office")}
                    >
                      <span className="icon-1">
                        <i className="fas fa-briefcase"></i>
                      </span>
                      <span className="text-1">Office</span>
                    </button>
                    <button
                      className={`icon-button-1 ${
                        selectedButton === "Other" ? "selected" : ""
                      }`}
                      onClick={() => handleButtonClick("Other")}
                    >
                      <span className="icon-1">
                        <i className="fas fa-ellipsis-h"></i>
                      </span>
                      <span className="text-1">Other</span>
                    </button>
                  </div>
                </div>
              )}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  )
}
